import type { FinAdvanceRetentionRow } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { Table } from '@shared/ui/Table';
import { formatDateRu, formatMoney } from '../financierFormat';
import {
  Section,
  SectionHeader,
  SectionTitle,
  Subtitle,
  TableWrap,
  RightTh,
  RightTd,
  TableNoticeTd,
  CounterpartyTitle,
  BoldText,
  DimSubText,
  PaidGreenTd,
  RemainingSkyTd,
} from './styled';
import { ADVANCE_STATUS_LABELS } from './types';

interface RetentionsSectionProps {
  retentionRows: FinAdvanceRetentionRow[];
}

export function RetentionsSection({ retentionRows }: RetentionsSectionProps) {
  return (
    <Section>
      <SectionHeader>
        <div>
          <SectionTitle>Гарантийные удержания (до ввода объекта в эксплуатацию)</SectionTitle>
          <Subtitle>
            Удержания заказчиков (замороженная выручка холдинга) и удержания с субподрядных организаций
          </Subtitle>
        </div>
      </SectionHeader>

      <TableWrap>
        <Table>
          <thead>
            <tr>
              <th>Направление удержания</th>
              <th>Контрагент</th>
              <th>Проект / Договор</th>
              <RightTh>Сумма удержания, ₽</RightTh>
              <RightTh>Возвращено по акту</RightTh>
              <RightTh>Остаток к возврату, ₽</RightTh>
              <th>Ожидаемый ввод объекта</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {retentionRows.length === 0 ? (
              <tr>
                <TableNoticeTd colSpan={8}>
                  Гарантийные удержания не зарегистрированы
                </TableNoticeTd>
              </tr>
            ) : (
              retentionRows.map((r: FinAdvanceRetentionRow) => {
                const statusConf = ADVANCE_STATUS_LABELS[r.status] ?? {
                  label: r.status,
                  tone: 'neutral',
                };
                return (
                  <tr key={r.id}>
                    <td>
                      <Badge
                        $tone={r.direction === 'receivable_retention' ? 'info' : 'neutral'}
                      >
                        {r.direction === 'receivable_retention'
                          ? 'Удержано Заказчиком'
                          : 'Удержано с субподрядчика'}
                      </Badge>
                    </td>
                    <td>
                      <CounterpartyTitle>{r.counterparty_name}</CounterpartyTitle>
                    </td>
                    <td>
                      <BoldText>{r.project_name}</BoldText>
                      <DimSubText>
                        Договор № {r.contract_number}
                      </DimSubText>
                    </td>
                    <RightTd>
                      <div>{formatMoney(r.initial_amount)}</div>
                    </RightTd>
                    <PaidGreenTd>
                      {formatMoney(r.settled_amount)}
                    </PaidGreenTd>
                    <RemainingSkyTd>
                      {formatMoney(r.remaining_amount)}
                    </RemainingSkyTd>
                    <td>
                      <div>{formatDateRu(r.expected_close_date)}</div>
                    </td>
                    <td>
                      <Badge $tone={statusConf.tone}>{statusConf.label}</Badge>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </TableWrap>
    </Section>
  );
}
